import { PROCEED_TO_CHECKOUT } from "../action/actionTypes";

const initialState = {
  checkoutItems: [],
  totalAmount: 0,
};

const checkReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROCEED_TO_CHECKOUT:
      return {
        ...state,
        checkoutItems: action.payload.items,
        totalAmount: action.payload.total,
      };
    default:
      return state;
  }
};

export default checkReducer;
